import Vue from 'vue'
import VueSimpleAlert from "vue-simple-alert"
import Master from './components/layouts/Master.vue'
import { store } from './store/store'
import VueRouter from 'vue-router'
import routes from './routes'
import 'materialize-css/dist/css/materialize.css'
import 'materialize-css/dist/js/materialize.min.js'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VueClipboard from 'vue-clipboard2'


Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueSimpleAlert)
Vue.use(Loading)
Vue.use(VueClipboard)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({
        name: 'login',
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  store: store,
  router: router,
  render: h => h(Master),
}).$mount('#app')
